import { Component, OnInit } from '@angular/core';

import { Router } from '@angular/router';
import { FormBuilder, FormGroup, Validators, FormsModule } from '@angular/forms';
import { first } from 'rxjs/operators';

//import { UserService } from '../../services/user.service';
import { CommonDataService } from '../../../services/common-data.service';

declare var $:any;
declare var iziToast:any;

@Component({
  selector: 'app-seller-info',
  templateUrl: './seller-info.component.html',
  styleUrls: ['./seller-info.component.scss']
})
export class SellerInfoComponent implements OnInit {
  
  pageName = "My Business Profile";
  modelForm: FormGroup;
  filesToUpload: Array<File> = [];
  phoneNumberPattern =this._data.validSAPhone
  websiteUrl = this._data.validWebUrl
  validEmail = this._data.validEmail

  constructor(
    private formBuilder: FormBuilder,
    private router: Router,
    private _data: CommonDataService
  ) { 

    $('#loader').show();
    //lets get the model for this page
  this._data.getProfile() 
  .pipe(first())
  .subscribe(
    data => {
      console.log(data);
      this.modelData = data['cover']['model']['modelData']['formFieldsEntities'];

      if(this.localModelDataStorage) {

        localStorage.setItem(this.modelName, JSON.stringify(data['cover']['model']['modelData']['formFieldsEntities'])); // save reference data in localStorage+

        this.modelData = JSON.parse(localStorage.getItem(this.modelName));

      }
    },
    error => {

      console.log(error);
      iziToast.success({
        title: 'Error!',
        position: 'topRight',
        icon: 'icon-circle-check',
        message: 'Failed to retrieve profile info.'
    });

    $('#loader').hide();

    },

    () => {
      this.prepopulate();
        $('#loader').hide();
    }
  );
  }

  localModelDataStorage = false;
  modelName = 'User';
  modelId = '0';
  modelData: any;
  returnData: any;
  files: any;

  ngOnInit() {

    $('#initialise-page').trigger('click');
    //$('#loader').hide();

  	  this.modelForm = this.formBuilder.group({

      bussiness_email: ['', Validators.required], 
      bussiness_name: ['', Validators.required], 
      bussiness_phone: ['', Validators.required], 
      bussiness_website: ['', Validators.required], 

      bussiness_address_1: ['', Validators.required], 
      bussiness_address_2: ['', Validators.required], 
      bussiness_city: [''], 
      bussiness_state: ['' ], 
      bussiness_postcode: ['', Validators.required], 
      bussiness_building: [''],
      payfastMerchantId: [''], 
      payfastMerchantKey: [''], 

    });
  }

  get f() { return this.modelForm.controls; }

  prepopulate(){

      for (var key in this.modelData) {  // 'field' is a string

        for (const field in this.modelForm.controls) {
            console.log(key)
          if(this.modelData[key][field]) {

            this.modelForm.get(field).setValue(this.modelData[key][field]);
            //const control = this.modelForm.get(field); // 'control' is a FormControl
            console.log(field);

            //console.log(control);
          }

        }

      }
  }

  onFileChanged(event) {
    //this.files = event.target.files[0];
    //this.modelForm.get('images').setValue(this.files);

    this.filesToUpload = <Array<File>>event.target.files;
  }

  onSubmit() {

    //alert('working magic!')
    $('#buttonText').text('Please Wait...');
    $('#loader').show();
    
    if (this.modelForm.invalid) {
      console.log('errors are detected')
      this.markFormGroupTouched(this.modelForm);

      $('#buttonText').text('Update Business Details ');
      $('#loader').hide();
      return;
    }

    console.log('Details being saved in the service: '+JSON.stringify(this.modelForm.value))

    this.createModel(); // run combine function
  }

  private markFormGroupTouched(formGroup: FormGroup) {
    (<any>Object).values(formGroup.controls).forEach(control => {
      control.markAsTouched();

      if (control.controls) {
        this.markFormGroupTouched(control);
      }
    });
  }

  createModel() {

    let modelObject1 = new FormData();

    modelObject1.append('modelName', this.modelName);
    modelObject1.append('objectName', 'businessDetails');
    modelObject1.append('id', this.modelId);
    modelObject1.append('bussiness_email', this.modelForm.controls['bussiness_email'].value);
    modelObject1.append('bussiness_name', this.modelForm.controls['bussiness_name'].value);
    modelObject1.append('bussiness_phone', this.modelForm.controls['bussiness_phone'].value);
    modelObject1.append('bussiness_website', this.modelForm.controls['bussiness_website'].value);

    modelObject1.append('bussiness_address_1', this.modelForm.controls['bussiness_address_1'].value);
    modelObject1.append('bussiness_address_2', this.modelForm.controls['bussiness_address_2'].value);
    modelObject1.append('bussiness_city', this.modelForm.controls['bussiness_city'].value);
    modelObject1.append('bussiness_state', this.modelForm.controls['bussiness_state'].value);
    modelObject1.append('bussiness_postcode', this.modelForm.controls['bussiness_postcode'].value);

    modelObject1.append('bussiness_building', this.modelForm.controls['bussiness_building'].value);
    modelObject1.append('ShopPayfastDetails-payfastMerchantId', this.modelForm.controls['payfastMerchantId'].value);
    modelObject1.append('ShopPayfastDetails-payfastMerchantKey', this.modelForm.controls['payfastMerchantKey'].value);

    //modelObject1.append('status', this.modelForm.controls['status'].value);

    const files: Array<File> = this.filesToUpload;
    console.log(files);

    for(let i =0; i < files.length; i++){
        modelObject1.append("files[]", files[i]);
    }


    this.updateModel(modelObject1);

  }

  updateModel (modelObject: any) {
    // Initiate new model creation/update method

    this._data.updateProfile(modelObject) 
      .pipe(first())
      .subscribe(
        data => {
 
          this.returnData = data;
          console.log('this is the new model return object: '+JSON.stringify(this.returnData));

          this.modelData = data['cover']['model']['modelData']['formFieldsEntities'];

        },
        error => {

          console.log(error);
          $('#buttonText').text('Update Business Details ');
          $('#loader').hide();

        },

        () => {
          iziToast.success({
              title: 'Success!',
              position: 'topRight',
              icon: 'icon-circle-check',
              message: 'Your profile updated successfuly.'
          });

          $('#buttonText').text('Update Business Details ');
          $('#loader').hide();
        }
      );
  }

}
